/*
Exemple:
endpointName: { // endpoint's name
  getterPropertyName: { // state getter property name
    name : 'AdviceModal', // name of the corresponding modal
      default: null, // default value of the property
      content: {
        image: '', // image name with extension
        alt: '' // image alt
        title: '', // i18n path to title
        summary: '', // i18n path to summary
    },
  },
} */

import boxImg from '@/assets/img/cartons_std.png';
import furnitureLiftImg from '@/assets/img/monte_meuble.png';
import wardrobeImg from '@/assets/img/cartons_penderie.png';

const floorAdvice = {
  modal: '',
  content: {
    title: 'advice.address.floor.title',
    summary: 'advice.address.floor.summary',
  },
};
const liftAdvice = {
  modal: '',
  content: {
    title: 'advice.address.all_in_lift.title',
    summary: 'advice.address.all_in_lift.summary',
  },
};
const stairsAdvice = {
  modal: '',
  content: {
    title: 'advice.address.stairs.title',
    summary: 'advice.address.stairs.summary',
  },
};
const parkingVlAdvice = {
  modal: '',
  content: {
    icon: ['fal', 'truck-moving'],
    title: 'advice.address.vl.title',
    summary: 'advice.address.vl.summary',
  },
};
const parkingPortageAdvice = {
  modal: '',
  content: {
    title: 'advice.address.portage.title',
    summary: 'advice.address.portage.summary',
  },
};
const mmAdvice = {
  modal: 'AdviceModal', // name of the corresponding modal
  modalContent: {
    summary: 'advice.address.mm_utilisable.modalContent',
  },
  content: {
    image: furnitureLiftImg,
    title: 'advice.address.mm_utilisable.title', // i18n path to title
    summary: 'advice.address.mm_utilisable.summary', // i18n path to summary
  },
};
const mmObligatoireAdvice = {
  modal: '',
  content: {
    image: furnitureLiftImg,
    title: 'advice.address.mm_obligatoire.title', // i18n path to title
    summary: 'advice.address.mm_obligatoire.summary', // i18n path to summary
  },
};
const dateAdvice = {
  modal: '',
  content: {
    title: 'advice.serviceOffer.dates.title',
    summary: 'advice.serviceOffer.dates.summary',
  },
};
const cartonAdvice = {
  modal: '',
  content: {
    image: boxImg,
    title: 'advice.serviceOffer.cartons.title',
    summary: 'advice.serviceOffer.cartons.summary',
  },
};
const wardrobeAdvice = {
  modal: '',
  content: {
    image: wardrobeImg,
    title: 'advice.serviceOffer.wardrobe.title',
    summary: 'advice.serviceOffer.wardrobe.summary',
  },
};
const mountAdvice = {
  modal: 'AdviceModal',
  modalContent: {
    summary: 'advice.serviceOffer.mount.modalContent',
  },
  content: {
    icon: ['fal', 'tools'],
    title: 'advice.serviceOffer.mount.title',
    summary: 'advice.serviceOffer.mount.summary',
  },
};
const fragileAdvice = {
  modal: 'AdviceModal',
  modalContent: {
    summary: 'advice.serviceOffer.fragile.modalContent',
  },
  content: {
    icon: ['fal', 'fragile'],
    title: 'advice.serviceOffer.fragile.title',
    summary: 'advice.serviceOffer.fragile.summary',
  },
};
const unbreakableAdvice = {
  modal: '',
  content: {
    title: 'advice.serviceOffer.unbreakable.title',
    summary: 'advice.serviceOffer.unbreakable.summary',
  },
};
const boxesAdvice = {
  modal: 'AdviceModal',
  modalContent: {
    summary: 'advice.boxes.modalContent',
  },
  content: {
    title: 'advice.boxes.title',
    summary: 'advice.boxes.summary',
  },
};
const deliveryBoxesAdvice = {
  modal: '',
  content: {
    title: 'advice.deliveryBoxes.title',
    summary: 'advice.deliveryBoxes.summary',
  },
};
const insuranceAdvice = {
  modal: 'AdviceModal',
  modalContent: {
    summary: 'advice.insurance.modalContent',
  },
  content: {
    title: 'advice.insurance.title',
    summary: 'advice.insurance.summary',
  },
};
const insuranceCompAdvice = {
  modal: '',
  content: {
    title: 'advice.insuranceComp.title',
    summary: 'advice.insuranceComp.summary',
  },
};
const inventoryAdvice = {
  modal: '',
  content: {
    title: 'advice.inventory.title',
    summary: 'advice.inventory.summary',
  },
};

function commitAdvice(store, newAdvice) {
  store.commit('adviceStore/SET_ADVICE', newAdvice, { root: true });
}

function unsetAdvice(store) {
  store.commit('adviceStore/UNSET_ADVICE', undefined, { root: true });
}

export default function advice(store) {
  store.subscribe((mutation, state) => {
    if (!mutation.type.startsWith('adviceStore')) {
      // unsetAdvice(store);
    }
    switch (mutation.type) {
      case 'loadingStore/SET_CAVE':
      case 'deliveryStore/SET_CAVE':
        if (state.routeStore.childRoute === 'housing') {
          commitAdvice(store, floorAdvice);
        }
        break;
      case 'loadingStore/SET_ALL_IN_LIFT':
      case 'deliveryStore/SET_ALL_IN_LIFT':
        if (state.routeStore.childRoute === 'furnitureTransport' && mutation.payload !== 1) {
          commitAdvice(store, stairsAdvice);
        }
        break;
      case 'loadingStore/SET_STAIRS':
      case 'deliveryStore/SET_STAIRS':
        if (state.routeStore.childRoute === 'furnitureTransport') {
          commitAdvice(store, mmAdvice);
        }
        break;
      case 'loadingStore/SET_LIFT_COMMENT':
      case 'deliveryStore/SET_LIFT_COMMENT':
        if (state.routeStore.childRoute === 'furnitureTransport') {
          commitAdvice(store, liftAdvice);
        }
        break;
      case 'loadingStore/SET_MM_UTILISABLE':
      case 'deliveryStore/SET_MM_UTILISABLE':
        if (state.routeStore.childRoute === 'furnitureTransport') {
          if (mutation.payload === -1 || mutation.payload === 1) {
            const routeType = state.routeStore.parentRoute;
            if (state[`${routeType}Store`][routeType].floor.stairs === 0) {
              commitAdvice(store, mmObligatoireAdvice);
            } else {
              commitAdvice(store, mmAdvice);
            }
          } else {
            unsetAdvice(store);
          }
        }
        break;
      case 'loadingStore/SET_MM_OBLIGATOIRE':
      case 'deliveryStore/SET_MM_OBLIGATOIRE':
        break;
      case 'loadingStore/SET_PARKING_TYPE':
      case 'deliveryStore/SET_PARKING_TYPE':
        if (state.routeStore.childRoute === 'parkingArea') {
          commitAdvice(store, parkingPortageAdvice);
        }
        break;
      case 'loadingStore/SET_PARKING_PORTAGE':
      case 'deliveryStore/SET_PARKING_PORTAGE':
        if (state.routeStore.childRoute === 'parkingArea') {
          commitAdvice(store, parkingVlAdvice);
        }
        break;
      case 'loadingStore/SET_PARKING_VL':
      case 'deliveryStore/SET_PARKING_VL':
        break;
      case 'serviceOfferStore/SET_DATES':
        break;
      case 'serviceOfferStore/SET_CARTONS':
        if (state.routeStore.childRoute === 'services') {
          commitAdvice(store, wardrobeAdvice);
        }
        break;
      case 'serviceOfferStore/SET_WARDROBES':
        if (state.routeStore.childRoute === 'services') {
          commitAdvice(store, mountAdvice);
        }
        break;
      case 'serviceOfferStore/SET_MOUNT':
        if (state.routeStore.childRoute === 'services') {
          commitAdvice(store, fragileAdvice);
        }
        break;
      case 'serviceOfferStore/SET_FRAGILE':
        if (state.routeStore.childRoute === 'services') {
          commitAdvice(store, unbreakableAdvice);
        }
        break;
      case 'serviceOfferStore/SET_UNBREAKABLE':
        break;
      case 'serviceOfferStore/SET_INSURANCE_VALUE':
        if (state.routeStore.childRoute === 'assurance') {
          commitAdvice(store, insuranceCompAdvice);
        }
        break;
      case 'serviceOfferStore/SET_INSURANCE_TYPE':
        break;
      case 'routeStore/SET_PARENT_ROUTE':
        unsetAdvice(store);
        break;
      case 'routeStore/SET_CHILD_ROUTE':
        switch (mutation.payload) {
          case 'services':
            commitAdvice(store, cartonAdvice);
            break;
          case 'dates':
            commitAdvice(store, dateAdvice);
            break;
          case 'boxConfig':
            commitAdvice(store, boxesAdvice);
            break;
          case 'assurance':
            commitAdvice(store, insuranceAdvice);
            break;
          case 'inventory':
            commitAdvice(store, inventoryAdvice);
            break;
          case 'boxDelivery':
            commitAdvice(store, deliveryBoxesAdvice);
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  });
}
